import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useFileTypes = () => {
  const { t } = useTranslation();
  const [type, setType] = useState();
  const defaultValues = [
    { label: t('FILE_TYPES.audio'), value: 'audio' },
    { label: t('FILE_TYPES.image'), value: 'image' },
    { label: t('FILE_TYPES.gif'), value: 'gif' },
    { label: t('FILE_TYPES.video'), value: 'video' },
    { label: t('FILE_TYPES.document'), value: 'document' },
  ];
  if (!type) {
    setType(defaultValues);
  }
  return type;
};

export { useFileTypes };
